import styled from '@emotion/native';
import { Skeleton, SkeletonProvider } from 'design-system';
import type React from 'react';
import { useWindowDimensions } from 'react-native';

interface PlaceholderProps {
  number: number;
}
const WrapperPlaceholder = styled.View<PlaceholderProps>(({ number = 0 }) => ({
  alignItems: number % 2 ? 'flex-start' : 'flex-end',
}));

const Placeholder = styled.View(() => {
  const { width } = useWindowDimensions();

  return {
    height: 100,
    width: width / 2.6,
    borderRadius: 15,
    margin: 5,
  };
});

export const ChatSkeleton: React.FC = () => {
  return (
    <>
      {Array(5)
        .fill(0)
        .map((_, i) => (
          <SkeletonProvider loading={true} key={i}>
            <WrapperPlaceholder number={i}>
              <Skeleton borderRadius={15}>
                <Placeholder />
              </Skeleton>
            </WrapperPlaceholder>
          </SkeletonProvider>
        ))}
    </>
  );
};
